import React, { Component } from 'react';
import { func, shape, string } from 'prop-types';
import axios from 'axios';
import { splitEvery } from 'ramda';

import { withCountryContext } from 'containers/withCountryContext';

import Loader from 'components/Loader';

import { tecDocUrl, PROVIDER_ID, basicAuth } from 'utils/constantsHelper';
import { langCode } from 'utils/currentLanguage';

export const withAssignedArticlesByIds = (WrappedComponent) => {
  return withCountryContext(
    class extends Component {
      constructor(props) {
        super(props);

        this.state = {
          loading: true,
          carsData: [],
        };
      }

      static propTypes = {
        getLinkedArticles: func.isRequired,
        contextCountry: shape({
          currentCountry: string.isRequired,
        }).isRequired,
      };

      getData = (cars) => {
        const currentCountry = this.props.contextCountry.currentCountry;
        axios
          .post(
            tecDocUrl,
            {
              getVehicleByIds4: {
                articleCountry: currentCountry,
                lang: langCode,
                country: currentCountry,
                countriesCarSelection: currentCountry,
                motorCodes: true,
                carIds: {
                  array: cars,
                },
                provider: PROVIDER_ID,
              },
            },
            { headers: basicAuth }
          )
          .then((response) => {
            if (response.status === 200 && response.data.data) {
              this.setState((prevState) => ({
                carsData: prevState.carsData.concat(response.data.data.array),
                loading: false,
              }));
            }
          })
          .catch(() => {
            this.setState({
              loading: false,
            });
          });
      };

      setCarsArray = () => {
        let cars = [];
        this.setState({
          carsData: [],
          loading: true,
        });

        if (this.props.data && this.props.data.array.length && this.props.data.array[0].articleLinkages && this.props.data.array[0].articleLinkages.array.length) {
          this.props.data.array[0].articleLinkages.array.forEach((element) => {
            cars.push(element.linkingTargetId);
          });
        } else {
          this.setState({
            loading: false,
          });
        }

        splitEvery(25, cars).forEach((group) => {
          this.getData(group);
        });
      };

      componentDidMount() {
        this.setCarsArray();
      }

      render() {
        if (this.state.loading) {
          return <Loader />;
        }

        return (
          <WrappedComponent
            getLinkedArticles={this.props.getLinkedArticles}
            getArticlesIDs={this.setCarsArray}
            carsData={this.state.carsData}
            loading={this.state.loading}
            {...this.props}
          />
        );
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/containers/withAssignedArticlesByIds/withAssignedArticlesByIds.js